import type { IModelConnection } from "@itwin/core-frontend";
import { QueryBinder, QueryRowFormat } from "@itwin/core-common";
import { Tabulation } from "../../../domain/contracts/Tabulation";
import { DOTPayItemIndex } from "./dotPayItemQuery";

const DOTPAYITEM_SCHEMA =
  "DgnCustomItemTypes_DOT_DigitalAssetMetadata";

/**
 * Build the ECSQL to read Tabulation info
 * for a given DOT_PayItem{index} aspect.
 */
function buildTabulationByElementQuery(
  index: DOTPayItemIndex,
): string {
  if (index < 1 || index > 5) {
    throw new Error(`Invalid DOT_PayItem index: ${index}`);
  }

  return `
    SELECT
      p.Tabulation.Class                        AS Class,
      p.Tabulation.Category                     AS Category,
      p.Tabulation.[Group]                      AS [Group],
      p.Tabulation.Code                         AS Code,
      p.Tabulation.DOT_DigitalAssetMetadata_ID_ AS ID,
      p.Tabulation.Title                        AS Title,
      p.Tabulation.SheetNum                     AS SheetNum
    FROM ${DOTPAYITEM_SCHEMA}.DOT_PayItem${index}ElementAspect p
    WHERE p.Element.Id = ?
  `;
}

export async function queryTabulationForElement(
  iModel: IModelConnection,
  elementId: string,
  index: DOTPayItemIndex,
): Promise<Tabulation | undefined> {
  const bindings = QueryBinder.from([elementId]);

  const reader = iModel.createQueryReader(
    buildTabulationByElementQuery(index),
    bindings,
    { rowFormat: QueryRowFormat.UseECSqlPropertyNames }
  );

  for await (const row of reader) {
    const plain = row.toRow() as any; // { Class, Category, Group, Code, ID, Title, SheetNum }
    return Tabulation.fromObject(plain);
  }

  // No Tabulation info for that element/index
  return undefined;
}

